var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPiscesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7344 21.623C20.726 21.623 17.4327 18.5124 17.1355 14.5789H19.9667C20.2758 14.5789 20.5267 14.328 20.5267 14.0189C20.5267 13.7098 20.2758 13.4589 19.9667 13.4589H17.1327C17.4116 9.50763 20.7132 6.37723 24.7344 6.37723C25.0435 6.37723 25.2944 6.12631 25.2944 5.81723C25.2944 5.50816 25.0435 5.25723 24.7344 5.25723C20.0953 5.25723 16.2906 8.8893 16.0099 13.4594H12.9891C12.7086 8.88977 8.9037 5.25723 4.26457 5.25723C3.95549 5.25723 3.70457 5.50816 3.70457 5.81723C3.70457 6.12631 3.95549 6.37723 4.26457 6.37723C8.28583 6.37723 11.5877 9.50763 11.8663 13.4594H9.0318C8.72273 13.4594 8.4718 13.7103 8.4718 14.0194C8.4718 14.3284 8.72273 14.5794 9.0318 14.5794H11.8631C11.566 18.5131 8.27253 21.6235 4.2641 21.6235C3.95503 21.6235 3.7041 21.8744 3.7041 22.1835C3.7041 22.4925 3.95503 22.7435 4.2641 22.7435C8.8904 22.7435 12.6865 19.1312 12.9859 14.5794H16.0122C16.3115 19.131 20.1077 22.7435 24.734 22.7435C25.043 22.7435 25.294 22.4925 25.294 22.1835C25.294 21.8744 25.0436 21.6232 24.7342 21.6232L24.7344 21.623Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiscesIcon);
export default __webpack_public_path__ + "static/media/pisces-icon.6b0f6199994a88b021a99bbfb112a7b4.svg";
export { ForwardRef as ReactComponent };